// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
import { useCallback, useEffect, useMemo, useRef, useState, memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzMasterAgGrid } from '../../components';
import { ADD_END_DUM_NOTICE_GRID_REF, gridDateFilter, setAddendumNoticeGridref } from '../../utils/global_functions';
import AddendDumReportStatusModal from './AddendDumReportStatusModal';
import moment from 'moment';

const AddednduNoticesContainer = ({ arrAddEndumNoticedReport }) => {


    const [isOpen, setIsOpen] = useState(false);
    const [selectedRowData, setSlectedRowData] = useState({});

    const LinkComponet = (props) => {
        const handleClick = () => {
            let field = props?.colDef?.field;
            const rowData = props.data;
            rowData['field'] = field;
            setSlectedRowData({ ...rowData });
            setIsOpen(true);
        };

        return (
            <a href="#" className='text-decoration-underline' style={{ color: 'blue', cursor: 'pointer' }} onClick={(e) => { e?.preventDefault(); handleClick(); }}>{props?.value}</a>
        );
    };

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const addenndumNoticesColDef = useMemo(() => [
        { field: 'notice_title', headerName: 'NOTICE TITLE', minWidth: 350, cellStyle: { textAlign: 'left' }, filter: 'agTextColumnFilter', flex: 1, cellRenderer: LinkComponet },
        { field: 'last_action', headerName: 'LAST INTERACTION', filter: 'agTextColumnFilter', flex: 1, cellRenderer: LinkComponet },
        {
            field: 'last_action_date_time', headerName: 'DATE & TIME', flex: 1, filter: 'agDateColumnFilter', cellRenderer: LinkComponet, filterParams: {
                comparator: gridDateFilter
            },
        },
    ], []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End




    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const handleAgGridAutoSize = useCallback(() => {
        ADD_END_DUM_NOTICE_GRID_REF?.current?.api?.sizeColumnsToFit();
    }, []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    useEffect(() => {
        // handleAgGridAutoSize();
    }, [handleAgGridAutoSize]);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const onCellDoubleClicked = useCallback((params) => {
        let field = params?.colDef?.field;
        const rowData = params.data;
        rowData['field'] = field;
        setSlectedRowData({ ...rowData });
        setIsOpen(true);
    }, []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const onGridReady = useCallback(() => {
        // ADD_END_DUM_NOTICE_GRID_REF?.current?.api?.sizeColumnsToFit();
    }, []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const handleOnHide = useCallback(() => {
        setIsOpen(false);
        setSlectedRowData({});
    }, []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End
    setAddendumNoticeGridref(useRef());



    return (
        <>
            <AddendDumReportStatusModal isOpen={isOpen} selectedRowData={selectedRowData} handleOnHide={handleOnHide} />

            <Container fluid className='p-0'>
                {/* <Row className='background-heading px-3 bdr-btm g-0'>
                    <Col className='d-flex align-items-center jusytify-content start'>
                        <div className='icon-14 icon-backward-arrow icon-dark me-3' onClick={handleOnHide}></div>
                        <div className='font-medium font-size3 color-text pt-1'>Addendum &amp; Notices</div>
                    </Col>
                </Row> */}
                <Row className='g-0'>
                    <Col className='p-3'>
                        <BzMasterAgGrid
                            isCompress={true}
                            id={'WACHLIST_ID'}
                            rowSelection='multiple'
                            arrColumnData={addenndumNoticesColDef} arrRowData={arrAddEndumNoticedReport}
                            rowHeight={36} className='ag-theme-alpine addendumnotice-container-ag-grid-wrapper'
                            ref={ADD_END_DUM_NOTICE_GRID_REF}
                            onGridReady={onGridReady}
                            onCellDoubleClicked={onCellDoubleClicked}
                        />
                    </Col>
                </Row>
            </Container >
        </>
    );
};

export default memo(AddednduNoticesContainer);
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End